import React from 'react'
import Header from '../Components/Header'
import { Link } from 'react-router-dom'
import hero from './../Images/home.png';
import social from './../Images/social-group.png';
import feature_1 from './../Images/feature-1.png';
import feature_2 from './../Images/feature-2.png';
import feature_3 from './../Images/feature-3.png';
import frame from './../Images/frame.png';
import testimonials from './../Images/testimonials.png';
import Development from './../Images/development.png';

import { FaHome, FaPlay, FaSearch } from "react-icons/fa";
import { IoArrowForward } from "react-icons/io5";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form'
import Properties from '../PageComponents/Properties';
import Testimonials from '../PageComponents/Testimonials';
import Footer from '../Components/Footer';


import Accordion from 'react-bootstrap/Accordion';

const Home = () => {
  return (
    <>
      <Header />
      {/* Hero starts*/}

      <div className="hero w-100">
        <div className="row">
          <div className="col-lg-7 order-lg-1 order-2">
            <div className="hero-desc ps-100 pt-5">
              <div className="hero-heading mb-4">
                <h1>Invest in your Dream Home.
                  You and your Family in a Happy Home. </h1>
                <p>VISTAPLOTS is the top real estate investment company in India assisting the clients to Invest in
                  the Right Real Estate Properties across Bangalore.</p>
              </div>
              <div className="hero-btns">
                <Link to="" className="common-btn me-4"><FaHome /> View Properties</Link>
                <Link to="" className="watch-videos"><span><FaPlay /></span> Watch Videos</Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 order-lg-2 order-1">
            <div className="hero-img">
              <img src={hero} alt="" />
            </div>
          </div>
        </div>
      </div>


      {/* Hero ends */}

      {/* search bar starts */}

      <div className="home-search rel-top">

        <div className="container">
          <div className="home-search-bx">
            <div className="home-search-top">

              <Tabs
                defaultActiveKey="Sale"
                variant='pills'
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="Sale" title="Sale">
                  <div className="home-search-inputs">
                    <form action="">
                      <div className="row">
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Enter Location</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Your City</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Property Type</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Property Type</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Price Range</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Price Range</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 my-auto text-center">

                          <div className="form-group">
                            <button type="submit" className="search-btn"><FaSearch /> Submit</button>

                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </Tab>
                <Tab eventKey="Rent" title="Rent">
                  <div className="home-search-inputs">
                    <form action="">
                      <div className="row">
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Enter Location</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Your City</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Property Type</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Property Type</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 mb-md-0 mb-4">
                          <div className="form-group">
                            <label>Price Range</label>
                            <Form.Select aria-label="Default select example">
                              <option>Select Price Range</option>
                              <option value="1">One</option>
                              <option value="2">Two</option>
                              <option value="3">Three</option>
                            </Form.Select>

                          </div>


                        </div>
                        <div className="col-md-3 my-auto text-center">

                          <div className="form-group">
                            <button type="submit" className="search-btn"><FaSearch /> Submit</button>

                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </Tab>
                {/* <Tab eventKey="contact" title="Contact" disabled>
      Hi there 3
      </Tab> */}
              </Tabs>
              <span>





              </span>
            </div>

          </div>
        </div>

      </div>
      {/* search bar ends */}


      {/* trusted by starts */}

      <div className="trusted-by py-60 mb-60">
        <div className="container">
          <div className="main-title-1 text-center">
            <h1>Trusted By</h1>
            <p>Trusted by
              over 20,000 companies all over the world</p>
          </div>
          <div className="w-100">
            <img src={social} className="w-100" alt="" />
          </div>
        </div>
      </div>
      {/* trusted by ends */}


      {/* features starts */}
      <div className="features-area mb-60">
        <div className="container">
          <div className="main-title-2 text-center mb-30">
            <h1>Our Features</h1>
            <p>VISTAPLOTS advisors will help you to Invest in your dream real estate project from a very small investment of 10,000 Rs/- onwards which can be encashed to buy your Dream Home or Commercial Properties soon. Save your family from the uncertainty and build your dream home in Bangalore. </p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4">
                <div className="feature-img text-center">

                  <img src={feature_1} alt="" />
                </div>
                <div className="feature-desc">
                  <h4>High Demand</h4>
                  <p>There is a great demand for the real estate market in Bangalor <Link to="">Learn More</Link></p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4">
                <div className="feature-img text-center">

                  <img src={feature_2} alt="" />
                </div>
                <div className="feature-desc">
                  <h4>Safe Future</h4>
                  <p>Save the Future of your Family by Investing in the right property in Bangalore. <Link to="">Learn More</Link></p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4">
                <div className="feature-img text-center">

                  <img src={feature_3} alt="" />
                </div>
                <div className="feature-desc">
                  <h4>RERA Approved</h4>
                  <p>Our Legal team will help you to choose the A Khata property which is RERA Approved. <Link to="">Learn More</Link></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* features ends */}

      {/* Development view starts */}
      <div className="dev-area mb-60">
        <div className="container">
          <div className="main-title-2 text-center d-flex flex-column align-items-center mb-30">
            <h1>Development View</h1>
            <p className='max-900'>Residential Layouts are ideally situated on a fastest developing areas. The entry level affordable investment concept is well deigned to grow almost double returns in short period.</p>
          </div>
<div className='dev-bx'>
          <div className="row">
            <div className="col-lg-6 order-lg-1 order-2">

              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Invest in the Commercial Property</Accordion.Header>
                  <Accordion.Body>
                    Commercial Properties are always the best source of the Investments for the people. The Increase in the Start-up companies and the International companies investing in the companies across India has led to a several people moving to Bangalore in the recent years. This Era will continue for at least for next 30 Years of time which can be capitalized by Investing in the commercial properties across Bangalore.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Tenants usually commit for 10 Years</Accordion.Header>
                  <Accordion.Body>
                    If you have a commercial property your tenants will be occupying your location at least for 10 Years of time. You would be tension free and you would be receiving the rents on the continuous basis without any problems pertaining to the Recessions.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Business Office Space or Retail Outlet</Accordion.Header>
                  <Accordion.Body>
                    Whether you are looking to Invest your Space as a Retail Space or Business/Corporate Offices, The Commercial Investment is the best option compared to the other Investments. Retail Offices provides you with 7% of the rent on the annual basis where the Business/Corporate Office Spaces provides you 12% of the rent on the annual basis.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Increased Capital Asset Appreciation </Accordion.Header>
                  <Accordion.Body>
                    Capital Asset appreciation is more in the Commercial Property compared to the Residential Property. The Capital Asset Appreciation in the commercial property is 10% Annually compared to the Residential Property which is only 5% to 6% per year.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>One Time Investment with good ROI</Accordion.Header>
                  <Accordion.Body>
                    The One Time Investment in the Commercial Property provides you a Good Return on Investment compared to the other Investment options such as Equity Investments Etc.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

            </div>
            <div className="col-lg-6 mb-lg-0 mb-4 order-lg-2 order-1 d-lg-flex justify-content-end">
              <div className="dev-img">
                <img src={Development} alt="" />
              </div>
            </div>

          </div>
          </div>
        </div>
      </div>


      {/* Development view ends */}


      {/*how to invest starts */}
      <div className="features-area mb-60">
        <div className="container">
          <div className="main-title-2 text-center mb-30">
            <h1>Our Features</h1>
            <p>VISTAPLOTS advisors will help you to Invest in your dream real estate project from a very small investment of 10,000 Rs/- onwards which can be encashed to buy your Dream Home or Commercial Properties soon. Save your family from the uncertainty and build your dream home in Bangalore. </p>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4 gr-card">
                <div className="feature-icon text-center">

                  <span><FaHome /></span>
                </div>
                <div className="feature-desc text-center p-mar">
                  <h4>Browse Offerings</h4>
                  <p>There is a great demand for the real estate market in Bangalore</p>
                </div>
                <div className="feature-link text-center">
                  <Link to="">Learn More <IoArrowForward /></Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4 gr-card">
                <div className="feature-icon text-center">

                  <span><FaHome /></span>
                </div>
                <div className="feature-desc text-center p-mar">
                  <h4>Browse Offerings</h4>
                  <p>Browse Offerings</p>
                </div>
                <div className="feature-link text-center">
                  <Link to="">Learn More <IoArrowForward /></Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4 gr-card">
                <div className="feature-icon text-center">

                  <span><FaHome /></span>
                </div>
                <div className="feature-desc text-center p-mar">
                  <h4>Browse Offerings</h4>
                  <p>There is a great demand for the real estate market in Bangalore</p>
                </div>
                <div className="feature-link text-center">
                  <Link to="">Learn More <IoArrowForward /></Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4 gr-card">
                <div className="feature-icon text-center">

                  <span><FaHome /></span>
                </div>
                <div className="feature-desc text-center p-mar">
                  <h4>Browse Offerings</h4>
                  <p>There is a great demand for the real estate market in Bangalore</p>
                </div>
                <div className="feature-link text-center">
                  <Link to="">Learn More <IoArrowForward /></Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="feature-bx p-4 gr-card">
                <div className="feature-icon text-center">

                  <span><FaHome /></span>
                </div>
                <div className="feature-desc text-center p-mar">
                  <h4>Browse Offerings</h4>
                  <p>There is a great demand for the real estate market in Bangalore</p>
                </div>
                <div className="feature-link text-center">
                  <Link to="">Learn More <IoArrowForward /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* how to invest ends */}

      {/* numbers starts */}
      <div className="num-bg mb-60" style={{ backgroundImage: `url(${frame})` }}>
        <div className="container">
          <div className="row">

            <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
              <div className="num text-center">
                <h3>2028</h3>
                <p>lorem ipsum</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
              <div className="num text-center">
                <h3>33</h3>
                <p>lorem ipsum</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
              <div className="num text-center">
                <h3>400</h3>
                <p>lorem ipsum</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-lg-0 mb-4">
              <div className="num text-center">
                <h3>133</h3>
                <p>lorem ipsum</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* numbers ends */}
      {/* featured starts */}
      <div className="dev-area mb-60">
        <div className="container">
          <div className="main-title-2 text-center d-flex flex-column align-items-center mb-30">
            <h1>Featured Property</h1>
            <p className='max-900'>Residential Layouts are ideally situated on a fastest developing areas. The entry level affordable investment concept is well deigned to grow almost double returns in short period.</p>
          </div>
          <div className="properties-list">
            <Properties />
          </div>
        </div>
      </div>
      {/* numbers ends */}

      {/* testimonials starts */}
      <div className="testimonials mb-70 py-60" style={{ backgroundImage: `url(${testimonials})` }}>
        <div className="container">
          <div className="testimonials-title">
            <h1>Our Customer Feedback</h1>
            <p>Don’t take our word for it. Trust our customers</p>
          </div>

          <div>
            <Testimonials />
          </div>
        </div>

      </div>
      {/* testimonials ends */}

      <Footer />
    </>
  )
}

export default Home